"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const handleOnDeleteFavorite = ({ content, contentFavoriteId, }) => {
    if (!contentFavoriteId)
        return content;
    return content.filter((x) => x.contentFavoriteId !== contentFavoriteId);
};
exports.default = handleOnDeleteFavorite;
